import { TableField } from "../../table-field";

const codigo: TableField = {
    key: "Codigo",
    label: "Codigo",
    tdClass: ["text-center", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
}
const uo: TableField = {
    key: "Nome",
    label: "Unidade Orçamentária",
    tdClass: ["text-center", "quebrarPorPalavra"],
    thClass: ["quebrarPorPalavraHard","text-center"],
}
const nomeResponsavel: TableField = {
    key: "ContatoUnidadeOrcamentaria.Nome",
    label: "Nome",
    tdClass: ["text-center", "quebrarPorPalavra"],
    thClass: ["quebrarPorPalavraHard","text-center"],
}
const email: TableField = {
    key: "ContatoUnidadeOrcamentaria.Email",
    label: "Email",
    tdClass: ["text-center", "naoQuebrar"],
    thClass: ["quebrarPorPalavraHard","text-center"],
}
const actions: TableField = {
    key: "actions",
    label: "",
    tdClass: "text-center",
}
export const fieldsUO: TableField[] = [
    codigo,
    uo,
    nomeResponsavel,
    email,
    actions
];